import { pickValuesFromColorScheme } from '../../../colorUtils';
import { stringLiteralsArray, pxToRem } from '../../../../utils';
export var formFieldColorAreas = stringLiteralsArray('foreground', 'background');
export var formFieldVariables = function formFieldVariables(siteVariables) {
  return {
    colorScheme: pickValuesFromColorScheme(siteVariables.colorScheme, formFieldColorAreas),
    messagePaddingLeft: pxToRem(12)
  };
};